import { IMG } from "./site";

export const JOURNAL_CATEGORIES = ["All", "Perspectives", "Materials", "Process", "Art & Objects", "Places"];

// Editorial placeholders. Replace with published articles via this file.
export const ARTICLES = [
  {
    slug: "the-weight-of-materials",
    title: "The weight of materials",
    category: "Materials",
    date: "2025-04-18",
    readingTime: "6 min",
    hero: IMG.journalMaterials,
    excerpt:
      "Why the way surfaces meet — and how they age — matters as much as the surfaces themselves.",
    intro:
      "A material is never only what it looks like. It is how it feels underhand, how it holds light, how it wears with use and time. In residential interiors, these quiet properties do more to shape a home's character than any single decorative gesture.",
    body: [
      "We tend to choose materials for their patina rather than their perfection — stone that carries the mark of the quarry, timber with visible grain, plaster that softens light rather than reflecting it. These are surfaces that improve with living.",
      "The junction between two materials is where craft becomes visible. A shadow gap, a bronze reveal, the precise meeting of stone and oak: these details are rarely noticed consciously, yet they are felt in the overall sense of resolution.",
    ],
    pullQuote:
      "The junction between two materials is where craft becomes visible.",
    inlineImage: IMG.materialStudy,
    inlineCaption: "Material study — plaster, stone, bronze and oak.",
  },
  {
    slug: "art-as-architecture",
    title: "Art as architecture",
    category: "Art & Objects",
    date: "2025-03-02",
    readingTime: "5 min",
    hero: IMG.journalArt,
    excerpt:
      "Art is not the last thing added to a room. It is part of how the room is conceived.",
    intro:
      "When art is considered early, walls, light and circulation can be shaped around it. A single piece, given room to breathe, can hold an entire space.",
    body: [
      "We think about placement, sightlines and lighting from the outset, treating art and objects as integral to the architecture rather than an afterthought applied at the end.",
      "The aim is never to decorate but to compose — to let a few considered pieces carry meaning and give a home its particular identity.",
    ],
    pullQuote: "A single piece, given room to breathe, can hold an entire space.",
    inlineImage: IMG.journalArt,
    inlineCaption: "Proposed interior — art and object placement.",
  },
  {
    slug: "renovating-period-homes",
    title: "Renovating period homes with restraint",
    category: "Process",
    date: "2025-01-21",
    readingTime: "7 min",
    hero: IMG.journalPeriod,
    excerpt:
      "How to introduce the contemporary into a period property without erasing its character.",
    intro:
      "Older homes arrive with a voice already established — cornices, proportions, the particular fall of light through tall windows. Our task is to listen before we speak.",
    body: [
      "We study what should be retained, repaired or revealed before proposing anything new. New interventions are then introduced with clarity, so that old and new read as distinct yet in dialogue.",
      "Where planning or listed-building considerations apply, appropriate consultants are appointed to guide the work sensitively and correctly.",
    ],
    pullQuote: "Our task is to listen before we speak.",
    inlineImage: IMG.journalPeriod,
    inlineCaption: "Existing condition — period detail retained and revealed.",
  },
];

export const getArticle = (slug) => ARTICLES.find((a) => a.slug === slug);
export const formatDate = (iso) =>
  new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" });
